// The /payments entry point for Stripe Connect "site links" (pages/payments.vue): which of the signed-in admin's clubs
// it means. Clubs with payments live are the real candidates; if none are enabled yet every club they administer is,
// so the link still lands somewhere useful.
export function paymentsCandidates(clubs) {
  const list = clubs ?? [];
  const withPayments = list.filter(c => c.paymentsEnabled);
  return withPayments.length > 0 ? withPayments : list;
}

/** A club's payments page, keeping ?tab= (and the rest of the query) from Stripe's link. */
export function paymentsTargetFor(clubId, query = {}) {
  return {path: `/admin/clubs/${clubId}/payments`, query};
}

/** Where /payments forwards: /admin with no club, the one club's payments, null when the page asks which. */
export function paymentsRedirectTarget(candidates, query = {}) {
  if (!candidates?.length) return '/admin';
  if (candidates.length === 1) return paymentsTargetFor(candidates[0].id, query);
  return null;
}
